const emailRegexStr = '^\\w+([\\.-]?\\w+)*@\\w+([\\.-]?\\w+)*(\\.\\w{2,3})+$';

export const emailRegex = new RegExp(emailRegexStr);

const phoneRegexStr = '^[\\+]?[(]?[0-9]{3}[)]?[-\\s\\.]?[0-9]{3}[-\\s\\.]?[0-9]{4,6}$';

export const phoneRegex = new RegExp(phoneRegexStr);
